import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/components/DashboardLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardHome from "@/pages/DashboardHome";
import EmployeesPage from "@/pages/EmployeesPage";
import RolesPage from "@/pages/RolesPage";
import FormBuilderPage from "@/pages/FormBuilderPage";
import FillFormPage from "@/pages/FillFormPage";
import SubmissionsPage from "@/pages/SubmissionsPage";
import ScannerPage from "@/pages/ScannerPage";
import PrintViewPage from "@/pages/PrintViewPage";
import SystemSettingsPage from "@/pages/SystemSettingsPage";

function Layout({ children }) {
  return <DashboardLayout>{children}</DashboardLayout>;
}

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
        <Toaster position="top-center" richColors closeButton dir="rtl" toastOptions={{ style: { fontFamily: "'Rubik', 'IBM Plex Sans Arabic', sans-serif" } }} />
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout><DashboardHome /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/employees"
            element={
              <ProtectedRoute permission="employees.view">
                <Layout><EmployeesPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/roles"
            element={
              <ProtectedRoute>
                <Layout><RolesPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/form-builder"
            element={
              <ProtectedRoute>
                <Layout><FormBuilderPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/form-builder/:id"
            element={
              <ProtectedRoute>
                <Layout><FormBuilderPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/forms"
            element={
              <ProtectedRoute permission="submissions.create">
                <Layout><FillFormPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/forms/edit/:id"
            element={
              <ProtectedRoute permission="submissions.create">
                <Layout><FillFormPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/submissions"
            element={
              <ProtectedRoute>
                <Layout><SubmissionsPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/scanner"
            element={
              <ProtectedRoute permission="scanner.use">
                <Layout><ScannerPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Layout><SystemSettingsPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/print/:id"
            element={
              <ProtectedRoute>
                <PrintViewPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
